<template>

  <nav>
    <div class="nav-wrapper" :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
      <div class="">
        <a href="#" data-target="slide-out" class="sidenav-trigger show-on-large">
          <i style="display: none" id="menulateralIcone"  class="material-icons">menu</i>
        </a>

        <a class="right" @click="compartilhar()">
          <i class="material-icons" :style="'font-size: 25px; color: #fff;margin-right: 7px;'">share</i>
        </a>

        <a class="right" @click="pesquisar()" style="display: block;margin-right: 10px">
          <i class="material-icons" id="menulateralIcone2"  :style="'font-size: 27px; color: #fff;margin-right: 10px;display: none'">search</i>
        </a>

        <a class="brand-logo">
          <div align="center"><img src="@/assets/logo-branco.png" class="logo"></div>
        </a>
        <ul id="slide-out" class="sidenav" :style="'background-color: ' + this.$store.state.empresa.cor_primaria + ''">
          <li>
            <div class="user-view">
              <a href="">
                <img src="@/assets/logo-branco.png" class="logo">
              </a>
            </div>
          </li>
          <li>
            <a href="#!" style="padding: 0 15px;font-size: medium">
              Grupos</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <li>
            <a
              v-for="grupo in this.$store.state.grupos"
              :key="'lateral-'+grupo.id"
              @click="selecionar('grupo-' + grupo.id)"
              class="waves-effect sidenav-close">
              {{ grupo.nome }}
            </a>
          </li>
        </ul>
      </div>

    </div>
    <slot></slot>
  </nav>

</template>

<script>

import Swal from "sweetalert2";

export default {
  name: "NavBar",
  data(){
    return{
      grupos: this.$store.state.grupos
    }
  },
  updated() {
    $(document).ready(function(){
      $('.dropdown-trigger').dropdown();
      $('.collapsible').collapsible();
      $('.sidenav').sidenav();
    });

    var elem = document.querySelector('.sidenav');
    var instance = M.Sidenav.init(elem, {
      onOpenStart: function () {
        // console.log("I trigger as soon as the page is loaded");
        document.getElementById("nav-grupo-conteiner").style = "display:none;"

      },
      onCloseEnd: function () {
        document.getElementById("nav-grupo-conteiner").style = "display:block;"
      }
    });
  },
  methods:{
    generateUrl() {
      return `https://pedido.sirruscook.app/${this.$store.state.empresa.usuario_url}${(!this.$store.state.is_producao ? '?homologacao=true' : '')}`;
    },
    async compartilhar()
    {
      if (navigator.share)
      {
        this.compartilharComImagem(this.generateUrl());
      } else {
        this.copiarParaAreaDeTransferencia(this.generateUrl());
      }
    },
    async compartilharComImagem(newUrl) {
      navigator.share({
        url: newUrl
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.error('Error sharing:', error));
    },
    copiarParaAreaDeTransferencia(texto) {
      const el = document.createElement('textarea');
      el.value = texto;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      Swal.fire({
        icon: 'success',
        title: 'Link copiado!',
        text: 'Agora você já pode compartilhar nosso cardápio :)'
      });
    },
    selecionar(grupo) {
      var elmnt = document.getElementById(grupo);
      elmnt.scrollIntoView(true);
      window.scrollBy(0, -100);
    },
    pesquisar(){
      this.$router.push("/" + this.$store.state.empresa_url + "/pesquisar");
    }
  }
}
</script>

<style scoped>

.logo {
  padding: 9px;
  width: 210px;
}

@media only screen and (max-width : 992px) {
  .logo {
    padding-top: 5px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}

.nav-grupo-conteiner{
  margin-top: 50px;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-grupo{
  background-color: #f2f2f2;
  /*height: 100px;*/
  height: auto;
}


nav i {
  line-height: 40px;
}

nav {
  /*color: #fff;*/
  /*background-color: #ee6e73;*/
  /*width: 100%;*/
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/NavBar.vue